<script setup lang="ts">
import { ref, computed } from "vue";

interface Props {
    translatedRoutes: { nl?: { relative_url: string; lang: string }; fr?: { relative_url: string; lang: string }; en?: { relative_url: string; lang: string } };
    inverse?: boolean;
}

defineProps<Props>();

const showLanguageDropdown = ref(false);

const lang = computed(() => {
    return document.documentElement.lang;
});
</script>

<template>
    <div key="languageswitch" class="relative select-none">
        <div @click="showLanguageDropdown = !showLanguageDropdown" class="cursor-pointer group w-[3.625rem] py-[.625rem] rounded-[.125rem] h-[2.375rem] flex items-center flex-1 transition-colors justify-center" :class="inverse ? 'text-primary bg-secondary/10 hover:bg-secondary/20' : 'text-white bg-white/10 hover:bg-white/20'">
            <div class="uppercase text-xs font-medium inline-flex leading-[1.125rem] items-center">
                {{ lang }}
                <svg-vue icon="icons/chevron-down" class="h-[1.125rem] w-auto ml-[.125rem] [&_path]:stroke-current"></svg-vue>
            </div>
        </div>
        <transition name="fade">
            <div v-if="showLanguageDropdown" class="w-12 absolute top-full left-1/2 -translate-x-1/2 pt-2">
                <div class="flex flex-col rounded-md items-stretch bg-white text-black border border-[#d8d8d8] py-2">
                    <a
                        class="p-2 text-[.875rem] text-center font-bold uppercase leading-[1.0625rem] hover:text-primary hover:bg-primary/10 transition-colors"
                        v-for="locale in Object.keys(translatedRoutes).filter((l) => l !== lang)"
                        :href="translatedRoutes[locale].relative_url.replace('?lang=' + locale, '').replace(/\/$/, '')"
                    >
                        {{ locale }}
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>
